import React from 'react';

import Modal from '@/core/components/Modal';
import BadgesControl from '@/core/components/UserControl/controls/BadgesControl';
import CguControl from '@/core/components/UserControl/controls/CguControl';
import DeleteControl from '@/core/components/UserControl/controls/DeleteControl';
import EmailCheckControl from '@/core/components/UserControl/controls/EmailCheckControl';
import EmailErrorControl from '@/core/components/UserControl/controls/EmailErrorControl';
import { InterestsControl } from '@/core/components/UserControl/controls/InterestsControl';
import NotificationControl from '@/core/components/UserControl/controls/NotificationControl';
import RsControl from '@/core/components/UserControl/controls/RsControl';
import UsernameControl from '@/core/components/UserControl/controls/UsernameControl';
import { useFF } from '@/core/lib/ff/ff.context';
import Store from '@/core/lib/new-architecture/store';
import { FeatureFlag } from '@/core/types/featureFlag.type';
import { UserControlType } from '@/core/types/users';

import WelcomeControl from './controls/WelcomeControl';

const controls = {
  [UserControlType.BADGES]: <BadgesControl />,
  [UserControlType.CGU]: <CguControl />,
  [UserControlType.DELETE]: <DeleteControl />,
  [UserControlType.EMAIL_CHECK]: <EmailCheckControl />,
  [UserControlType.EMAIL_ERROR]: <EmailErrorControl />,
  [UserControlType.INTERESTS]: <InterestsControl />,
  [UserControlType.NOTIFICATIONS]: <NotificationControl />,
  [UserControlType.RS]: <RsControl />,
  [UserControlType.USERNAME]: <UsernameControl />,
  [UserControlType.WELCOME]: <WelcomeControl />,
};

const UserControl: React.FC = () => {
  const { data: current } = Store.current.useCurrent();
  const hasFFBadges = useFF(FeatureFlag.BADGES);

  if (!current?.control) return null;

  const ControlComponent = controls[current.control.type];

  if (!ControlComponent) return null;

  if (ControlComponent.type.name === 'BadgesControl' && !hasFFBadges) return null;

  const modalType = current.control.type === UserControlType.NOTIFICATIONS ? 'popup' : 'tunnel';

  return (
    <Modal isOpen onClose={() => {}} closeOnEscape={false} type={modalType}>
      <div className="h-full">{ControlComponent}</div>
    </Modal>
  );
};

export default UserControl;
